import { createAction, props } from '@ngrx/store';

import {
  LoginRequest,
  LoginWithSocialMediaRequest,
  RegistrationRequest,
  LoginResponse,
  UserBusiness,
} from '@offconon/core-api';

import { AuthEntity } from './auth.models';
export const initAuth = createAction('[Auth Page] Init');

export const loadAuthSuccess = createAction(
  '[Auth/API] Load Auth Success',
  props<{ auth: AuthEntity[] }>(),
);

export const loadAuthFailure = createAction(
  '[Auth/API] Load Auth Failure',
  props<{ error: any }>(),
);

export const resetAuth = createAction('[Auth/user] Reset');

export const setClientId = createAction(
  '[Auth/set clientId] Set clientId',
  props<{ clientId: string }>(),
);

export const setFcmId = createAction('[Auth/set fcmId] Set fcmId', props<{ fcmId: string }>());

export const resetFcmId = createAction('[Auth/reset fcmId] Reset fcmId');

export const setInvitationCode = createAction(
  '[Auth/set invitationCode] Set invitationCode',
  props<{ invitationCode: string }>(),
);

export const authLogin = createAction(
  '[Auth Page] Login',
  props<{ auth: LoginRequest; returnUrl: string }>(),
);

export const authSocialLogin = createAction(
  '[Auth Page] Social Login',
  props<{ auth: LoginWithSocialMediaRequest; returnUrl?: string }>(),
);

export const loginSuccess = createAction(
  '[Auth/API] Login Success',
  props<{ loginResponse: LoginResponse; returnUrl?: string }>(),
);

export const authRegister = createAction(
  '[Auth Page] Register',
  props<{ auth: RegistrationRequest; url: string }>(),
);

export const registerSuccess = createAction(
  '[Auth/API] Register Success',
  props<{ url: string }>(),
);

export const authSetLoadingState = createAction(
  '[Auth/API] Set Loading State',
  props<{ loading: boolean }>(),
);

export const refreshUserData = createAction(
  '[Auth/API] Refresh User Data',
  props<{
    data: {
      username?: string;
      jwt_token?: string;
      refresh_token?: string;
      action_method?: string;
      has_personal_erp?: boolean;
      avatar_path?: string;
      full_name?: string;
      is_verified?: boolean;
      is_subscription?: boolean;

      subscription_type?: LoginResponse.SubscriptionTypeEnum;
      subscription_icon?: string;
      subscription_icon_color?: string;
      media_album_id?: number;
      default_email?: string;
    };
  }>(),
);

export const setBusinessEntity = createAction(
  '[Core/Entity/Entity] Set business',
  props<{
    business: UserBusiness;
  }>(),
);

export const setUserEntity = createAction('[Core/Entity/Entity] Set user');
export const setChatSettings = createAction(
  '[Core/Entity/Entity] Set chat settings',
  props<{ settings: any }>(),
);
